import React from "react"
export function EzcancelLogoMono(props) {
  return (
    <svg viewBox="0 0 133 25" {...props}>
      <defs>
        <filter
          x="-4.6%"
          y="-4.7%"
          width="109.1%"
          height="108.9%"
          filterUnits="objectBoundingBox"
          id="prefix__filter-3"
        >
          <feOffset dy={-2} in="SourceAlpha" result="shadowOffsetInner1" />
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            operator="arithmetic"
            k2={-1}
            k3={1}
            result="shadowInnerInner1"
          />
          <feColorMatrix
            values="0 0 0 0 0.129411765 0 0 0 0 0.129411765 0 0 0 0 0.129411765 0 0 0 0.116559222 0"
            in="shadowInnerInner1"
          />
        </filter>
        <path
          d="M.311 2.997C-1.129 12.224 2.43 19.225 10.987 24c8.326-4.394 11.897-11.395 10.712-21.003l-3.654-1.629a17.297 17.297 0 00-14.093.004L.31 2.997z"
          id="prefix__path-1"
        />
      </defs>
      <g
        id="prefix__Product-Logos"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__EzCancel" transform="translate(0 1)">
          <path
            d="M39.677 21.993v-3.14h-6.696v-5.177h6.357v-2.999h-6.357V5.981h6.696V2.897H29.308v19.096h10.37zm12.969 0v-3.31H49.448l-.315.001-.318.001a53.48 53.48 0 00-1.82.027l5.538-8.205V7.933H42.7v3.225h2.487a65.48 65.48 0 002.995-.057L42.53 19.42v2.574h10.115zm11.217.255c1.78 0 3.503-.34 4.916-.849l-.424-3.281c-.989.452-2.543.792-3.701.792-3.843 0-5.566-2.32-5.566-6.479 0-3.706 1.751-6.394 5.311-6.394 1.3 0 2.6.198 3.843.566l.396-3.338c-1.244-.34-2.685-.51-4.04-.51-6.386 0-9.55 4.244-9.55 10.298 0 4.753 2.147 9.195 8.815 9.195zm11.188.028c2.09 0 3.814-1.103 4.493-2.687l.028.028c-.113.736-.141 1.556-.141 2.376h3.418a78.344 78.344 0 01-.085-3.62v-5.857c0-3.056-1.27-4.894-5.792-4.894-1.808 0-3.616.367-5.029.877l.311 3.027c1.187-.68 2.882-1.104 4.153-1.104 2.035 0 2.741.764 2.741 2.235v.764c-4.775 0-8.109 1.783-8.109 5.15 0 2.263 1.47 3.705 4.012 3.705zm1.102-2.772c-1.045 0-1.667-.594-1.667-1.5 0-1.131.848-2.235 4.662-2.235v.34c0 1.697-1.215 3.395-2.995 3.395zm14.184 2.49v-6.79c0-2.462 1.44-4.555 3.277-4.555 1.328 0 1.723.877 1.723 2.348v8.996h3.589V12.12c0-2.461-1.017-4.498-4.182-4.498-2.288 0-3.927 1.16-4.775 2.829l-.028-.029c.141-.735.198-1.839.198-2.49H86.72v14.061h3.617zm17.856.254c1.497 0 2.882-.283 3.843-.65l-.283-3.084c-.763.396-1.808.594-2.769.594-2.401 0-3.334-1.641-3.334-4.046 0-2.66 1.159-4.357 3.447-4.357.904 0 1.78.227 2.543.51l.367-3.14a10.9 10.9 0 00-2.882-.397c-4.972 0-7.26 3.367-7.26 7.752 0 4.781 2.429 6.818 6.328 6.818zm12.63.028c1.751 0 3.531-.31 5.029-.905l-.34-2.8c-1.214.565-2.712.876-4.096.876-2.6 0-3.9-1.273-3.87-3.904h8.701c.085-.594.113-1.16.113-1.64 0-3.48-1.808-6.281-5.905-6.281-4.21 0-6.583 3.168-6.583 7.468 0 4.951 2.486 7.186 6.95 7.186zm1.95-9.194h-5.171c.197-1.698 1.243-2.801 2.74-2.801 1.526 0 2.487 1.047 2.43 2.8zM133 21.993V1.341h-3.617v20.652H133z"
            fill="currentColor"
            fillRule="nonzero"
          />
          <g id="prefix__Logo">
            <mask id="prefix__mask-2" fill="#fff">
              <use xlinkHref="#prefix__path-1" />
            </mask>
            <g id="prefix__Mask">
              <use fill="currentColor" xlinkHref="#prefix__path-1" />
              <use
                fill="#000"
                filter="url(#prefix__filter-3)"
                xlinkHref="#prefix__path-1"
              />
            </g>
            <path
              d="M10.91 4.79a5.86 5.86 0 015.866 5.857 5.86 5.86 0 01-5.866 5.856 5.86 5.86 0 01-5.865-5.856A5.86 5.86 0 0110.91 4.79zm3.422 4.88H7.489v1.953h6.843V9.67z"
              id="prefix__Combined-Shape-Copy"
              fill="#FFF"
              fillRule="nonzero"
              mask="url(#prefix__mask-2)"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
